"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllDayEventDecorator = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
const dateUtil_1 = require("./dateUtil");
class AllDayEventDecorator {
    /**
     * プレーンなイベントをタイムラインの表示用のイベントに変換して返す
     * @param events
     * @returns
     */
    static decorate(events) {
        return events.reduce((acc, event, index) => {
            if (index === 0) {
                acc.push({
                    event,
                    rowIndex: 0
                });
                return acc;
            }
            // 1つ前のイベント
            const rowIndex = this.calcRowIndex(event, acc);
            acc.push({
                event,
                rowIndex
            });
            return acc;
        }, []);
    }
    /**
     * 渡されたイベントの中で最も終日予定の被りが多い日付の被りの数を返す
     * 表示するときの高さに使用。
     * 値がないときに-1を返すと
     * allDayEventHeight * (-1 + +1) = 0
     * になって都合がいいので-1を返しておく。
     * @param events
     * @returns
     */
    static maxRowIndex(events) {
        if ((0, lodash_1.isEmpty)(events)) {
            return -1;
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, lodash_1.maxBy)(events, (ev) => ev.rowIndex).rowIndex;
    }
    /**
     * eventを配置するindexを計算する
     * 0から始めて空いているindexが見つかるまでインクリメントする
     */
    static calcRowIndex(event, events) {
        let rowIndex = 0;
        // 複数日のイベントの場合も考慮して、全ての日付が空いているかチェックする必要がある
        const eventDays = (0, date_fns_1.eachDayOfInterval)(event.period);
        while (eventDays.some((date) => this.isOccupiedDateIndex(date, rowIndex, events))) {
            rowIndex++;
        }
        return rowIndex;
    }
    /**
     * 指定した日付、インデックスが取られているインデックスかを判定する
     * インデックスが同じで期間がかぶっているものがある場合は
     * そのIndexは利用できない
     * @param date 配置したい日付
     * @param index 配置したいindex
     * @param events
     * @returns
     */
    static isOccupiedDateIndex(date, rowIndex, events) {
        return events.some((ev) => {
            return (ev.rowIndex === rowIndex &&
                (0, dateUtil_1.isOverlap)(ev.event.period, { start: date, end: (0, date_fns_1.endOfDay)(date) }));
        });
    }
}
exports.AllDayEventDecorator = AllDayEventDecorator;
//# sourceMappingURL=allDayEventDecorator.js.map